/**
 * API service for communicating with the WandererTrip backend.
 * Handles serialization, envelope wrapping, and error handling.
 * Uses the shared apiClient for auth and fetch.
 */

import { apiPut } from './apiClient';
import type { PublishedPayload } from '../types/publishedTrip';

export interface ApiResult {
  success: boolean;
  error?: string;
}

/**
 * Publish the planned trip payload to the backend via PUT /jsontransfer.
 * Uses publishId as the envelope id (e.g. user email or custom key).
 * Body is the structured payload with trip section and per-city documents.
 * Auth is handled automatically by apiClient.
 */
export async function publishPlannedTrip(
  publishId: string,
  payload: PublishedPayload
): Promise<ApiResult> {
  try {
    await apiPut(publishId, 'plannedTrip', payload);
    return { success: true };
  } catch (err) {
    const message = err instanceof Error ? err.message : 'An unexpected error occurred.';
    return { success: false, error: message };
  }
}
